/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseBrandInfo
 */
export interface GetConfig200ResponseBrandInfo {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseBrandInfo
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseBrandInfo
     */
    locationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseBrandInfo
     */
    brandId: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseBrandInfo
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseBrandInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseBrandInfo
     */
    coverImageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseBrandInfo
     */
    colorLogoImageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseBrandInfo
     */
    faviconImageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseBrandInfo
     */
    accentColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseBrandInfo
     */
    secondaryColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseBrandInfo
     */
    topbarColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseBrandInfo
     */
    backgroundImageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseBrandInfo
     */
    backgroundColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseBrandInfo
     */
    squareLogo?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseBrandInfo
     */
    position?: number | null;
}

/**
 * Check if a given object implements the GetConfig200ResponseBrandInfo interface.
 */
export function instanceOfGetConfig200ResponseBrandInfo(value: object): value is GetConfig200ResponseBrandInfo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('brandId' in value) || value['brandId'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseBrandInfoFromJSON(json: any): GetConfig200ResponseBrandInfo {
    return GetConfig200ResponseBrandInfoFromJSONTyped(json, false);
}

export function GetConfig200ResponseBrandInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseBrandInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'locationId': json['locationId'],
        'brandId': json['brandId'],
        'enabled': json['enabled'],
        'name': json['name'],
        'coverImageId': json['coverImageId'] == null ? undefined : json['coverImageId'],
        'colorLogoImageId': json['colorLogoImageId'] == null ? undefined : json['colorLogoImageId'],
        'faviconImageId': json['faviconImageId'] == null ? undefined : json['faviconImageId'],
        'accentColor': json['accentColor'] == null ? undefined : json['accentColor'],
        'secondaryColor': json['secondaryColor'] == null ? undefined : json['secondaryColor'],
        'topbarColor': json['topbarColor'] == null ? undefined : json['topbarColor'],
        'backgroundImageId': json['backgroundImageId'] == null ? undefined : json['backgroundImageId'],
        'backgroundColor': json['backgroundColor'] == null ? undefined : json['backgroundColor'],
        'squareLogo': json['squareLogo'] == null ? undefined : json['squareLogo'],
        'position': json['position'] == null ? undefined : json['position'],
    };
}

export function GetConfig200ResponseBrandInfoToJSON(json: any): GetConfig200ResponseBrandInfo {
    return GetConfig200ResponseBrandInfoToJSONTyped(json, false);
}

export function GetConfig200ResponseBrandInfoToJSONTyped(value?: GetConfig200ResponseBrandInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'locationId': value['locationId'],
        'brandId': value['brandId'],
        'enabled': value['enabled'],
        'name': value['name'],
        'coverImageId': value['coverImageId'],
        'colorLogoImageId': value['colorLogoImageId'],
        'faviconImageId': value['faviconImageId'],
        'accentColor': value['accentColor'],
        'secondaryColor': value['secondaryColor'],
        'topbarColor': value['topbarColor'],
        'backgroundImageId': value['backgroundImageId'],
        'backgroundColor': value['backgroundColor'],
        'squareLogo': value['squareLogo'],
        'position': value['position'],
    };
}

